module.exports = __webpack_public_path__ + "static/img/logo-zbgz.614afdf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-zbgz.png
// module id = 8L5k
// module chunks = 1